import type { ReactNode } from "react"

function buildButtonChildren(
  buttonType: "text" | "icon-prefix" | "icon-suffix" | "icon-solo" | undefined,
  iconNode: ReactNode,
  text: ReactNode
): ReactNode {
  if (buttonType === "icon-prefix") {
    return iconNode ? (
      <>
        {iconNode}

        {text}
      </>
    ) : (
      text
    )
  }

  if (buttonType === "icon-suffix") {
    return iconNode ? (
      <>
        {text}

        {iconNode}
      </>
    ) : (
      text
    )
  }

  return text
}

export default buildButtonChildren
